/*
 * please follow the wiki: http://wiki.corp.qunar.com/pages/viewpage.action?pageId=105923056
 * @providesModule QFontSet
 */
'use strict'

module.exports = {
    'low_price_rn': 'https://s.qunarzz.com/low_price_rn/iconfont/0.0.7/low_price_rn.ttf',
    'hotel_rn_num_v1':'https://s.qunarzz.com/flight_shark/lowPriceRn/hotel_rn_num.ttf'
};
